/**
 * This file cannot directly do the initialization, because of the module federation setup. Instead, we import the
 * bootstrap procedure. Without this approach, we get error `Shared module is not available for eager consumption`
 * during the load of the application.
 *
 * @see https://webpack.js.org/concepts/module-federation/#uncaught-error-shared-module-is-not-available-for-eager-consumption
 */
import('./bootstrap');
